$(document).ready(function() {
$('.convenience-section .stat-card:last-child').on("click", function () {
    $.fancybox.open({
        src: "https://cdn.shopify.com/s/files/1/0573/1182/1872/files/Section_2.png?v=1764684907",
        type: "image",
        opts: {
            animationEffect: "zoom"
        }
    });
});
});
